export default __webpack_public_path__ + "static/media/up.15da0708.svg";